/** Title-case a name token: first character upper, remainder lower. Hyphens preserved. */
export function titleCaseNamePart(value: string | null | undefined): string {
  const trimmed = String(value || '').trim();
  if (!trimmed) return '';
  return trimmed
    .split(/(-)/)
    .map((part) => {
      if (part === '-' || !part) return part;
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    })
    .join('');
}

export function formatAuthNoticePersonName(
  firstName: string | null | undefined,
  lastName: string | null | undefined
): string {
  return `${titleCaseNamePart(firstName)} ${titleCaseNamePart(lastName)}`.trim();
}

export function formatMmddyy(date: Date = new Date()): string {
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yy = String(date.getFullYear()).slice(-2);
  return `${mm}${dd}${yy}`;
}

export type AuthNoticeKind = '7-Day' | '3-Day';

/** Generated title / filename stem: "Firstname Lastname 7-Day MMDDYY" — no DOB or IDs. */
export function formatAuthNoticeDocumentName(
  firstName: string | null | undefined,
  lastName: string | null | undefined,
  kind: AuthNoticeKind,
  date: Date = new Date()
): string {
  return `${formatAuthNoticePersonName(firstName, lastName)} ${kind} ${formatMmddyy(date)}`;
}
